const NULLISH_MESSAGES = new Set(["null", "undefined", ""]);
const GENERIC_ERROR_NAMES = new Set(["error", "typeerror", "referenceerror"]);

const DEFAULT_MESSAGE =
    "Something interrupted this page. Please refresh and try again.";

const PUBLIC_ASSESSMENT_MESSAGE =
    "We could not load the assessment page. Check your internet connection, refresh, and try again. If it keeps happening, ask your teacher for help or try Chrome.";

const isNullishMessage = (text: string): boolean =>
    NULLISH_MESSAGES.has(text.trim().toLowerCase());

/** Normalize any thrown/reported value into text safe to show users (never "null"). */
export const formatDisplayError = (
    errorInfo: unknown,
    options?: { publicAssessment?: boolean }
): string => {
    const fallback = options?.publicAssessment
        ? PUBLIC_ASSESSMENT_MESSAGE
        : DEFAULT_MESSAGE;

    if (errorInfo == null) return fallback;

    const candidates: string[] = [];

    if (typeof errorInfo === "string") {
        candidates.push(errorInfo);
    } else if (errorInfo instanceof Error) {
        candidates.push(errorInfo.message);
        if (!isNullishMessage(errorInfo.message)) {
            candidates.push(errorInfo.name);
        }
    } else if (typeof errorInfo === "object") {
        const record = errorInfo as Record<string, unknown>;
        for (const key of ["value", "message", "reason", "detail"]) {
            const part = record[key];
            if (typeof part === "string") candidates.push(part);
        }
    }

    const message = candidates
        .map((text) => text.trim())
        .find(
            (text) =>
                text &&
                !isNullishMessage(text) &&
                !GENERIC_ERROR_NAMES.has(text.toLowerCase())
        );

    return message || fallback;
};

export const isPublicAssessmentPath = (pathname = window.location.pathname): boolean =>
    /^\/(BL|EL)\/[^/]+\/[^/]+/.test(pathname) ||
    /^\/assess\/[^/]+(?:\/(?:test\/[^/]+|[^/]+\/[^/]+))/.test(pathname);
